import { ChangeDetectionStrategy, Component, ElementRef, Output, ViewChild, EventEmitter, Input } from '@angular/core';

import { IAdditionalComponentsCatalogueCart } from '../../../../enclosure/models/product-accessories.model';
import { IBomModel } from '../../../../prisma-xs/models/bom.model';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-add-additional-components-from-catalogue-modal',
    templateUrl: './add-additional-components-from-catalogue-modal.component.html',
    styleUrl: './add-additional-components-from-catalogue-modal.component.scss',
    standalone: false
})
export class AddAdditionalComponentsFromCatalogueModalComponent {
  @ViewChild('addAdditionalComponentsFromCatalogModal') addAdditionalComponentsFromCatalogModalElement: ElementRef;

  @Input() productsInCart: IAdditionalComponentsCatalogueCart[];
  @Input() productsWithAdjustedQuantity: IBomModel[];

  @Output() cancelModal = new EventEmitter();
  @Output() confirm = new EventEmitter();

  openModal() {
    jQuery(this.addAdditionalComponentsFromCatalogModalElement.nativeElement).modal('show');
  }

  cancelAddingProducts() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.addAdditionalComponentsFromCatalogModalElement.nativeElement).modal('hide');
    this.cancelModal.emit();
  }

  confirmAddingProducts() {
    jQuery(this.addAdditionalComponentsFromCatalogModalElement.nativeElement).modal('hide');
    this.confirm.emit();
  }
}
